import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../hooks/useGoodsSno';
import { useSameMarketRecommendOnly } from '../hooks/useSameMarketRecommendOnly';

export const useSimilarGoods = (enabled: boolean) => {
  const goodsSno = useGoodsSno();
  // 기획전 이벤트 연관상품 off 실험: 커버 연관(유사) 상품은 요청하지 않는다.
  const sameMarketRecommendOnly = useSameMarketRecommendOnly();

  return useQuery({
    queryKey: queryKey.similarGoods(goodsSno),
    queryFn: () => goodsService.getSimilarGoods(goodsSno),
    enabled: enabled && !sameMarketRecommendOnly,
  });
};
